import { useState } from "react";
import { inject, observer } from "mobx-react";
import moment from "moment";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputSwitch } from "primereact/inputswitch";
import { RadioButton } from "primereact/radiobutton";
import UploadUI from "@UI/UploadUI";
import ButtonUI from "@UI/ButtonUI";
import { read, utils } from "xlsx";

import "./style.scss";

const dataRadioButton = [
    { name: "Да", key: true },
    { name: "Нет", key: false },
];

const defaultRatesArray = {
    counts: null,
    ratesId: null,
};

const ActivateFileCode = inject("mainStore")(
    observer(({ mainStore, vendors, rates, tabItems }) => {
        const [data, setData] = useState({ offerId: null, dateStart: null, dateEnd: null, ratesArray: [defaultRatesArray] });
        const [radioItem, setRadioItem] = useState(dataRadioButton[0]);
        const [ratesVendor, setRatesVendor] = useState([]);
        const [radioItemPrice, setRadioItemPrice] = useState(dataRadioButton[1]);
        const date = new Date(Date.now() - 24 * 60 * 60 * 1000);

        const ratesFilter = ratesVendor && ratesVendor.length ? rates.filter((el) => ratesVendor.includes(el._id) && !el.archived) : [];

        const handleUpload = async (event) => {
            const file = event.files[0];
            const reader = new FileReader();

            reader.onload = async (e) => {
                const bstr = e.target.result;
                const wb = read(bstr, { type: "array", raw: true });

                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];

                const dataCodes = utils.sheet_to_json(ws, { header: 1 }).map((i, idx) => {
                    const cellAddress = utils.encode_cell({ r: idx, c: 1 });
                    const cellBid = utils.encode_cell({ r: idx, c: 2 });
                    const bidCell = ws?.[cellBid];
                    const cell = ws?.[cellAddress];

                    let isoDate = null;

                    if (!i[0]) {
                        mainStore.setMainStore("toast", { severity: "error", summary: `В файле ошибка с кодами, проверьте файл!!!!` });
                        return;
                    }

                    if (cell) {
                        if (cell.t === "n") {
                            isoDate = moment(cell.w, "D/M/YY").format("DD.MM.YYYY");
                        } else if (cell.t === "s" && typeof cell.v === "string") {
                            const parts = cell.v.split(".");
                            if (parts.length === 3) {
                                const [day, month, year] = parts;
                                // Валидация: все части должны быть числами
                                if (day && month && year && /^\d+$/.test(day) && /^\d+$/.test(month) && /^\d+$/.test(year)) {
                                    const y = year.length === 2 ? `20${year}` : year; // на случай 25 → 2025
                                    const d = day.padStart(2, "0");
                                    const m = month.padStart(2, "0");
                                    isoDate = `${d}.${m}.${y}`;
                                }
                            }
                        }
                    }

                    if (radioItemPrice.key) {
                        return i[1] ? { code: i[0], date: isoDate, bid: parseFloat(bidCell.v.replace(",", ".")) } : { code: i[0] };
                    }

                    return i[1] ? { code: i[0], date: isoDate } : { code: i[0] };
                });

                const obj = {
                    ...data,
                    codesArray: dataCodes,
                    type: "fileWithCodes",
                    dateEnd: data.dateEnd ? moment(data.dateEnd).format("DD.MM.YYYY") : null,
                    dateStart: data.dateStart ? moment(data.dateStart).format("DD.MM.YYYY") : null,
                    offerId: data.offerId ? data.offerId._id : null,
                    isTotalRevenue: false,
                    customRates: data.customRates ? data.customRates : false,
                    activationCounts: Math.max(...data.ratesArray.map((i) => i.counts)),
                    isPrice: radioItemPrice.key,
                };

                const resp = await mainStore.postByUrl(`/promo/upload_activatios_by_type`, obj);

                if (resp && resp.success) {
                    event.options.clear();
                    mainStore.setMainStore("toast", { severity: "success", summary: `Было найдено ${dataCodes.length} дублей. Загружено ${dataCodes.length} Активаций ` });
                    setData({ offerId: null, dateStart: null, dateEnd: null, ratesArray: [defaultRatesArray] });
                    setRadioItem(dataRadioButton[0]);
                }
            };

            reader.readAsArrayBuffer(file);
        };

        const countryTemplate = (option) => {
            const type = tabItems.find((i) => i.key === option.cpoType);
            return (
                <div className="multi__item">
                    <div className={`item__label ${option.cpoType === "percentAmount" ? "yellow" : option.cpoType === "rateGradation" ? "blue" : ""}`}>{type.label}</div>
                    {option.cpoType === "rateGradation" ? null : <div>{option.rate}</div>}
                    <div>{option.comments}</div>
                </div>
            );
        };

        const selectTemp = (option) => {
            if (option) {
                const typeLabel = tabItems.find((i) => i.key === option.cpoType)?.label || "";
                return (
                    <div className="multi__item">
                        <div className={`item__label ${option.cpoType === "percentAmount" ? "yellow" : option.cpoType === "rateGradation" ? "blue" : ""}`}>{typeLabel}</div>
                        {option.cpoType === "rateGradation" ? null : <div>{option.rate}</div>}
                        <div>{option.comments}</div>
                    </div>
                );
            } else {
                return <div>Укажите ставку</div>;
            }
        };

        const handleChange = (item, index, value, type) => {
            const newRates = data.ratesArray;
            newRates[index] = { ...item, [type]: value };
            setData((prev) => {
                return { ...prev, ratesArray: newRates };
            });
        };

        return (
            <div className="activate__file">
                <Dropdown
                    value={data.offerId}
                    onChange={(e) => {
                        setRatesVendor(e.value.rateIds);
                        setData((prev) => {
                            return { ...prev, offerId: e.value };
                        });
                    }}
                    options={vendors ? vendors : []}
                    optionLabel="name"
                    placeholder="Укажите вендор"
                    className="dropdown"
                    filter
                />

                <div className="radio__block">
                    <label className="label">Указаны ли в файле даты активации?</label>
                    <div className="button__radio">
                        {dataRadioButton.map((category) => {
                            return (
                                <div key={category.key} className="radio">
                                    <RadioButton inputId={category.key} name="category" value={category} onChange={(e) => setRadioItem(e.value)} checked={radioItem.key === category.key} />
                                    <label className="radio-label">{category.name}</label>
                                </div>
                            );
                        })}
                    </div>
                </div>

                <div className="radio__block">
                    <label className="label">Данные о стоимости</label>
                    <div className="button__radio">
                        {dataRadioButton.map((category) => {
                            return (
                                <div key={category.key} className="radio">
                                    <RadioButton inputId={category.key} name="category" value={category} onChange={(e) => setRadioItemPrice(e.value)} checked={radioItemPrice.key === category.key} />
                                    <label className="radio-label">{category.name}</label>
                                </div>
                            );
                        })}
                    </div>
                </div>

                {!radioItem.key ? (
                    <div className="date__block">
                        <label className="label">Укажите диапазон активаций</label>
                        <div className="input__block">
                            <div className="input__block item">
                                <Calendar
                                    value={data.dateStart}
                                    onChange={(e) =>
                                        setData((prev) => {
                                            return { ...prev, dateStart: e.value };
                                        })
                                    }
                                    dateFormat="С dd.mm.yy"
                                    placeholder="Укажите диапазон активаций"
                                    maxDate={date}
                                />
                                <i className="pi pi-calendar"></i>
                            </div>

                            <div className="input__block item">
                                <Calendar
                                    value={data.dateEnd}
                                    onChange={(e) =>
                                        setData((prev) => {
                                            return { ...prev, dateEnd: e.value };
                                        })
                                    }
                                    dateFormat="По dd.mm.yy"
                                    placeholder="Укажите диапазон активаций"
                                    minDate={data.dateStart}
                                    maxDate={date}
                                />
                                <i className="pi pi-calendar"></i>
                            </div>
                        </div>
                    </div>
                ) : null}

                {!radioItemPrice.key
                    ? data.ratesArray.map((item, idx) => (
                          <div className="block" key={idx}>
                              <div className="wrapper">
                                  <label className="label">Введите количество активаций</label>
                                  <InputNumber value={item.counts} onValueChange={(e) => handleChange(item, idx, e.value, "counts")} style={{ width: "100%" }} placeholder="100 000 000" />
                              </div>
                              <div className="switch">
                                  <InputSwitch checked={item.customRates} onChange={(e) => handleChange(item, idx, e.value, "customRates")} />
                                  <label className="switch__label">Кастомная ставка</label>
                              </div>

                              {!item.customRates ? (
                                  <div className="radio__block">
                                      <label className="label">Укажите ставку</label>
                                      <Dropdown
                                          value={item.ratesId}
                                          onChange={(e) => handleChange(item, idx, e.value, "ratesId")}
                                          options={ratesFilter ? ratesFilter : []}
                                          placeholder="Укажите ставку"
                                          className="dropdown"
                                          valueTemplate={selectTemp}
                                          itemTemplate={countryTemplate}
                                          disabled={!data.offerId}
                                          optionValue="_id"
                                      />
                                  </div>
                              ) : (
                                  <div className="wrapper">
                                      <label className="label">Укажите кастомную ставку (с НДС)</label>
                                      <InputNumber
                                          value={item.priceWithNds}
                                          onValueChange={(e) => handleChange(item, idx, e.value, "priceWithNds")}
                                          style={{ width: "100%" }}
                                          placeholder="Введите ставку"
                                          locale="ru-RU"
                                          mode="currency"
                                          currency="RUB"
                                      />
                                  </div>
                              )}
                          </div>
                      ))
                    : null}

                {!radioItemPrice.key ? (
                    <ButtonUI
                        label="Добавить ставку"
                        icon="pi pi-plus"
                        outlined
                        onClick={() =>
                            setData((prev) => {
                                return { ...prev, ratesArray: prev.ratesArray.concat(defaultRatesArray) };
                            })
                        }
                    />
                ) : null}

                <UploadUI handleUpload={handleUpload} formats="CSV" />
            </div>
        );
    }),
);

export default ActivateFileCode;
